module.exports = __webpack_public_path__ + "media/assets/images/kasai_first_view_botton-f0c503004687a821af50450535ab505d.png";